<template>
  <div>
    <v-container fluid grid-list-md text-xs-center pa-3>
      <v-layout row wrap>

        <v-flex xs12 text-xs-left>  
          <v-btn color="info" @click="zoomIn()"><v-icon>zoom_in</v-icon></v-btn>
          <v-btn color="info" @click="zoomOut()"><v-icon>zoom_out</v-icon></v-btn>
          <v-btn color="info" @click="fileDownload(pdfPath)">Descargar PDF<v-icon right>file_download</v-icon></v-btn>
        </v-flex>

        <v-flex xs12 text-xs-left>
          <v-pagination v-model="currentPage" :length="pageCount"></v-pagination>
        </v-flex>
        
        <v-flex xs12>
          <v-progress-linear color="success" v-if="loadedRatio<100" v-model="loadedRatio"></v-progress-linear>
          <pdf
            :src="src"
            :page="currentPage"
            :style="{ width: zoom + '%' }"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
          >
          </pdf>
        </v-flex>
      </v-layout>
    </v-container>    
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  name: "PdfViewer",
  props: ["pdfPath", "showPdfViewer"],
  components: {
    pdf
  },
  mounted() {
    this.src = pdf.createLoadingTask(this.$props.pdfPath);

    this.src.onProgress = (progressData) => {
      this.loadedRatio = 100 * progressData.loaded / progressData.total
    };
  },
  data() {
    return this.initialData();
  },
  computed: {
    noPrevPage() {
      return this.currentPage <= 1;
    },
    noNextPage() {
      return this.currentPage === this.pageCount;
    }
  },
  methods: {
    initialData() {
      return {
        currentPage: 1,
        pageCount: 0,
        src: null,
        zoom: 100,
        loadedRatio: 0
      };
    },
    prevPage() {
      this.currentPage--;
    },
    nextPage() {
      this.currentPage++;
    },
    fileDownload(url) {
      window.open(url)
    },
    zoomIn() {
      this.zoom += 10
    },
    zoomOut() {
      if (this.zoom > 10) {
        this.zoom -= 10  
      }
    }
  },
  beforeDestroy() {
    Object.assign(this.$data, this.initialData());
  }
};
</script>
